export const semaphore_url = 'https://us-central1-cortex-edp-dev.cloudfunctions.net/sendSmsNotication';